import React from 'react';
import '../../FormBuilder.css';

const DateTimeElement = ({ component, isRequired }) => {
  const renderElement = () => {
    return (
      component.elementName === 'dateTime' && (
        <label className='titleTextLbl'>
            {component.fieldName || "dateTime"}
            <span className='requiredContainer' style={{ color: 'red' }}>{isRequired(component)}</span>
        </label>
      )
    );
  };

  return (
    <div className='renderAllElements'>
      {renderElement()}
    </div>
  );
};

export default DateTimeElement;
